import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { Button, Typography } from "@mui/material";

const Wrapper = styled.div`
  height: 100%;
  padding: ${({ theme }) => theme.spacing(6)};
  text-align: center;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: ${({ theme }) => theme.spacing(10)};
  }
`;

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

function Page404() {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Helmet title="404 Error" />

      <Typography variant="h1" align="center" gutterBottom>
        404
      </Typography>

      <Typography variant="h5" align="center" gutterBottom>
        Page not found.
      </Typography>

      <Typography variant="body1" align="center" gutterBottom>
        The page you are looking for might have been removed.
      </Typography>

      <StyledButton
        onClick={() => navigate(-1)}
        variant="contained"
        color="secondary"
      >
        Back
      </StyledButton>
    </Wrapper>
  );
}

export default Page404;
